import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import useEntitesTable from "./useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddEquipmentDialog from "./AddEquipmentDialog.js";
import EditEquipmentDialog from "./EditEquipmentDialog";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { makeStyles, withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import { site } from "variables/patrimoine.js";
import { getSite } from "services/ConfigServices";
import Edit from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import {  NotificationManager } from 'react-notifications';

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const Equipments = (props) => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { parameters } = props;
  const {
    gridState,
    error,
    refetch,
    invalidate,
    handleClose,
  } = useEntitesTable(
    parameters,
    <AddEquipmentDialog
      parameters={parameters}
      closeModal={() => handleClose()}
      refetch={() => refetch()}
      deleteCounter={() => handleDeleteCounterChange()}
    />,
    "Nouvel équipement",
    "Ajout d'un équipement",
    "Liste équipements"
  );
  const [deleteCounter, setDeleteCounter] = useState(0);
  const [open, setOpen] = useState(false);
  const [prevEquipList, setPrevEquipList] = useState();
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [name, setName] = useState("");
  const [clef, setClef] = useState("");
  const [type, setType] = useState("");

  const handleDeleteCounterChange = (e) => {
    setDeleteCounter((prevCounter) => prevCounter + 1);
  };

  const handleNameChange = (event) => {setName(event.target.value);};
  const handleClefChange = (event) => {setClef(event.target.value);};
  const handleTypeChange = (event) => {setType(event.target.value);};  

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  let dataEquipements = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      name: site.renewables.equipmentlist.name,
      selector: row => row.name,
      sortable: true,
    },
    {
      name: site.renewables.equipmentlist.key,
      selector: row => row.clef,
      sortable: true,
    },
    {
      name: site.renewables.equipmentlist.type,
      selector: row => row.type,
      sortable: true,
    },
    realestateupdate ?
    {
      name: "Actions",
      sortable: true,
      width: "8rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Button
              color={"success"}
              className={classes.actionButton}
              onClick={editEquipment(row)}
            >
              <Edit className={classes.icon} />
            </Button>
            <CustomDeleteButton
              deleteTitle={"Suppression de l'équipement"}
              deleteSubTitle={
                "Êtes-vous sûr de vouloir supprimer l'équipement?"
              }
              handleSupprimer={deleteEquipment(row)}
            />
          </div>
        </>
      ),
    } : {},
  ];

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "renewables.equipmentlist"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPrevEquipList(res.data.detail?.renewables?.equipmentlist || []);
      });

  }, [deleteCounter]);


  const [idSelected, setIdSelected] = useState();

  const editEquipment = (row) => async () => {
    let obj = dataEquipements.find((o) => o.uuid === row.uuid);
    handleClickOpen();

    setIdSelected(obj.uuid);
    setName(obj.name);
    setClef(obj.clef);
    setType(obj.type);
  };

  const deleteEquipment = (row) => async () => {
    let obj = dataEquipements.find((o) => o.uuid === row.uuid);
    const indexToReplace = dataEquipements.findIndex((x) => x.uuid === obj.uuid);
    const equipmentlist = prevEquipList;
    equipmentlist.splice(indexToReplace, 1);
    axios
      .put(
        getSite(chartIdGroup, "renewables.equipmentlist"),
        equipmentlist,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Equipement supprimé");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
        refetch();
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          onSelectedRowsChange={updateState}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleEditClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
            Modifier l'équipement
          </DialogTitle>
          <DialogContent dividers>
            <EditEquipmentDialog
              parameters={parameters}
              closeModal={handleEditClose}
              refetch={refetch}
              idSelected={idSelected}
              prevEquipList={prevEquipList}
              name={name}
              clef={clef}
              type={type}
              handleNameChange={handleNameChange}
              handleClefChange={handleClefChange}
              handleTypeChange={handleTypeChange}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Equipments;
